import React from 'react';
import { Stand8 } from "../components/stands/Stand8";
import { Stand4 } from "../components/stands/Stand4";
import { Stand6 } from "../components/stands/Stand6";
import { StandS } from "../components/stands/StandS";
import { StandMS } from "../components/stands/StandMS";
import { StandPPS } from "../components/stands/StandPPS";
import { Rectangle } from "../components/stands/Rectangle";
import { grey, lightBlue, orange, yellow } from "@material-ui/core/colors";

export const mapConfig = (t) => ({
    mapWidth: 1200,
    mapHeight: 350,
    backgroundTitle: "ITP Area",
    walls: <polyline points="1110,175 1160,175 1160,235 1110,235 1110,280 1030,280 1030,255 960,255 960,280 900,280
    900,255 895,255 895,280 835,280 835,230 780,230 780,255 700,255 700,
    300 630,
    300 630,
    255 590,255 590,230 550,230 550,
    300 470,
    300 470,
    250 350, 250 350, 230 290,230 290,290 180,290 180,255 35,255 35,175 235,175 235,35 455,35 455,105 660,105 660,35 880,35 880,175 1040,175" stroke={grey['400']} fill="none" />,
    stands: [
        //Other
        <Rectangle x="1045" y="30" width={60} height={150} text={t("PSS_AREA").toUpperCase()} fill={orange['500']} />,
        // Jobwalls
        <Rectangle x="950" y="240" width={60} height={15} text={"JOBWALL"} fill={'none'} textColor={'black'} />,
        <Rectangle x="500" y="240" width={60} height={15} text={"JOBWALL"} fill={'none'} textColor={'black'} />,
        <Rectangle x="220" y="180" width={60} height={15} text={"JOBWALL"} fill={'none'} textColor={'black'} />,
        <Rectangle x="690" y="240" width={60} height={15} text={"JOBWALL"} fill={'none'} textColor={'black'} />,

        // CV consultacions
        <Rectangle x="925" y="255" width={35} height={20} text={"CV"} fill={yellow['500']} textColor={'black'} />,
        <Rectangle x="990" y="180" width={20} height={35} text={"CV"} fill={yellow['500']} textColor={'black'} />,

        <Rectangle x="470" y="300" width={80} height={20} text={t("ENTRANCE").toUpperCase()} fill={lightBlue['500']} />,

        // LEFT SIDE
        <StandS id="S1" x="240" y="135" reversed />,
        <Stand6 id="L3" x="240" y="105" reversed />,
        <Stand6 id="L2" x="270" y="65" />,
        <Stand8 id="L1" x="300" y="65" />,
        <Stand6 id="L4" x="360" y="65" />,
        <Stand6 id="L5" x="390" y="65" />,
        <Stand4 id="P6" x="420" y="65" />,

        // MIDDLE-LEFT SIDE
        <Stand4 id="L6" x="310" y="140" />,
        <Stand4 id="L7" x="310" y="160" />,
        <Stand6 id="L8" x="330" y="140" />,
        <Stand6 id="L9" x="330" y="160" />,
        <Stand6 id="L10" x="360" y="140" />,
        <Stand6 id="L11" x="360" y="160" />,
        <Stand4 id="L12" x="390" y="140" reversed />,
        <Stand4 id="L13" x="390" y="160" reversed />,
        <StandS id="S3" x="410" y="140" reversed />,

        <StandS id="S2" x="430" y="230" />,

        // MIDDLE
        <StandMS id="SG" x="590" y="110" />,
        <Stand6 id="P4" x="610" y="232" />,
        <Rectangle x="530" y="110"
            width={40} height={20}
            text={t("BEST").toUpperCase()}
            fill={lightBlue['500']} />,

        // MIDDLE-RIGHT SIDE
        <StandS id="S4" x="700" y="140" reversed />,
        <Stand4 id="P14" x="720" y="140" />,
        <Stand4 id="P15" x="720" y="160" />,
        <Stand6 id="P12" x="740" y="140" />,
        <Stand4 id="P10" x="770" y="140" />,
        <Stand6 id="P13" x="740" y="160" />,
        <Stand4 id="P11" x="770" y="160" reversed />,
        <StandS id="S5" x="790" y="140" reversed />,

        // RIGHT SIDE
        <Stand4 id="P1" x="675" y="65" />,
        <Stand6 id="P2" x="695" y="65" />,
        <Stand6 id="P3" x="725" y="65" />,
        <Stand8 id="P7" x="780" y="65" />,
        <Stand6 id="P17" x="820" y="65" />,

        <Stand6 id="P5" x="855" y="125" reversed />,
        <Stand8 id="P8" x="855" y="155" reversed />,
        <StandS id="S6" x="880" y="180" />,
        <Stand6 id="P9" x="920" y="180" />,
        <StandPPS id="PSS" x="1105" y="185" reversed />,
    ]
});